import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type SettingsSolidIconProps = IconProps;

export const SettingsSolidIcon = forwardRef<
  SVGSVGElement,
  SettingsSolidIconProps
>(function SettingsSolidIcon(props: SettingsSolidIconProps, ref) {
  return (
    <Icon
      data-testid="SettingsSolidIcon"
      aria-label="settings solid"
      viewBox="0 0 12 12"
      ref={ref}
      {...props}
    >
      <path d="M6 .996c.328 0 .621-.094.879-.281.266-.188.453-.426.563-.715.32.078.629.18.926.305s.582.273.855.445c-.125.281-.16.578-.105.891s.195.586.422.82c.156.148.328.262.516.34a1.484 1.484 0 0 0 1.206-.023c.164.273.309.562.434.867.125.297.227.605.305.926a1.5 1.5 0 0 0-.985 1.43c0 .328.09.625.27.891.188.258.426.441.715.551-.078.32-.18.633-.305.938a6.595 6.595 0 0 1-.434.855 1.466 1.466 0 0 0-.316-.105 1.48 1.48 0 0 0-.89.082 1.693 1.693 0 0 0-.516.34c-.227.234-.367.508-.422.82s-.02.609.105.891c-.273.172-.559.32-.855.445s-.605.223-.926.293a1.52 1.52 0 0 0-.563-.715c-.258-.18-.551-.27-.879-.27s-.625.09-.891.27a1.552 1.552 0 0 0-.551.715c-.32-.07-.629-.168-.926-.293s-.582-.273-.855-.445c.125-.281.16-.578.105-.891s-.195-.586-.422-.82a1.687 1.687 0 0 0-.516-.34 1.484 1.484 0 0 0-1.207.023 6.79 6.79 0 0 1-.434-.855 6.542 6.542 0 0 1-.305-.938c.289-.109.523-.293.703-.551.188-.266.281-.563.281-.891S.888 5.38.701 5.122a1.482 1.482 0 0 0-.703-.551c.078-.32.18-.629.305-.926.125-.305.27-.594.434-.867.102.047.203.082.305.105a1.48 1.48 0 0 0 .902-.082c.187-.078.359-.191.516-.34.227-.234.367-.508.422-.82s.02-.609-.105-.891A5.93 5.93 0 0 1 4.558 0c.109.289.293.527.551.715.266.188.563.281.891.281zm0 7.508a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
    </Icon>
  );
});
